import { render, staticRenderFns } from "./CountList.vue?vue&type=template&id=6edb1d2b&scoped=true&"
import script from "./CountList.vue?vue&type=script&lang=js&"
export * from "./CountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edb1d2b",
  null
  
)

export default component.exports